<ion-header class="extendido">
  <ion-buttons left>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>
    <ion-title>{{'Políticas de Privacidade' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="trix-content" [innerHTML]="privacidade | safeHtml: 'html'"></div>
</ion-content>